/**
 * Created by camiel on 21/04/2017.
 */

import Sound = createjs.Sound;

import AssetManager from "lib/src/AssetManager";

export type KeyboardKeyId =
  "1_C2" | "3_D2" | "5_E2" | "6_F2" | "8_G2" |
  "10_A2" | "12_B2" | "13_C3" | "15_D3" | "17_E3" | "2_C#2" |
  "4_D#2" | "7_F#2" | "9_G#2" | "11_A#2" | "14_C#3" | "16_D#3";

const WHITE_KEY_IDS: KeyboardKeyId[] = [
  "1_C2",
  "3_D2",
  "5_E2",
  "6_F2",
  "8_G2",
  "10_A2",
  "12_B2",
  "13_C3",
  "15_D3",
  "17_E3",
];

const BLACK_KEY_IDS: KeyboardKeyId[] = [
  "2_C#2",
  "4_D#2",
  "7_F#2",
  "9_G#2",
  "11_A#2",
  "14_C#3",
  "16_D#3",
];

export function isWhiteKey(keyboardKeyId: KeyboardKeyId): boolean {
  for (const whiteKeyboardKeyId of WHITE_KEY_IDS) {
    if (whiteKeyboardKeyId === keyboardKeyId) {
      return true;
    }
  }

  return false;
}

export function keyCodeToKeyId(key: number): KeyboardKeyId {
  const keymap = {
    65: "1_C2",   // a
    87: "2_C#2",    // w
    83: "3_D2",   // s
    69: "4_D#2",    // e
    68: "5_E2",   // d

    70: "6_F2",   // f
    84: "7_F#2",    // t
    71: "8_G2",   // g
    89: "9_G#2",    // y
    72: "10_A2",  // h
    85: "11_A#2",   // u
    74: "12_B2",  // j

    75: "13_C3",  // k
    79: "14_C#3",   // o
    76: "15_D3",  // l
    80: "16_D#3",   // p
    59: "17_E3",  // ; firefox
    186: "17_E3"  // ;
  }

  return keymap[key];
}

export type InstrumentId =  "drums" | "guitar" | "piano" | "trumpet";

const INSTRUMENT_IDS: InstrumentId[] = [
  "piano",
  "guitar",
  "drums",
  "trumpet",
];

export default class KeyboardSounds {
  public static whiteKeyIds: ReadonlyArray<KeyboardKeyId> = Object.freeze(WHITE_KEY_IDS);
  public static blackKeyIds: ReadonlyArray<KeyboardKeyId> = Object.freeze(BLACK_KEY_IDS);
  public static instrumentIds: ReadonlyArray<InstrumentId> = Object.freeze(INSTRUMENT_IDS);

  constructor(
    private readonly _instrumentId: string,
    private readonly _extension: string = "mp3",
  ) {
    this._registerSounds();
  }

  public playSound(keyboardKeyId: KeyboardKeyId) {
    Sound.play(this.getSoundId(keyboardKeyId));
  }

  private _registerSounds(): void {
    KeyboardSounds
      .whiteKeyIds
      .concat(KeyboardSounds.blackKeyIds)
      .forEach((keyboardKeyId) => {
        const soundPath = AssetManager.getShared(
          `sound/${this.getSoundId(keyboardKeyId)}.${this._extension}`,
        );

        Sound.registerSound(soundPath, this.getSoundId(keyboardKeyId));
      });
  }

  private getSoundId(keyboardKeyId: KeyboardKeyId): string {
    return `${this._instrumentId}/${keyboardKeyId}`;
  }
}



// WEBPACK FOOTER //
// ./src/KeyboardSounds.ts